/**
 * `@microsoft/voice-widget-embed` — defines `<voice-agent>` with the built-in Voice
 * Live provider, so a single `<script>` tag or a single import is a working widget.
 *
 * Ships as `dist/index.js` (ESM; dependencies stay external so a consumer's
 * `registerProvider` and the element share one registry) and `dist/index.global.js`
 * (self-contained IIFE for a plain `<script>` tag).
 *
 * To bring your own provider instead, use `@microsoft/voice-widget-embed/provider-neutral`.
 */
import "@microsoft/voice-widget-provider-voicelive"; // side effect: self-registers "voicelive"

export * from "./provider-neutral";
